import { type ReactElement } from 'react';
import NoIndex from '../components/NoIndex';

/**
 * Impressum (Anbieterkennzeichnung nach § 5 DDG).
 * Betreiber: Einzelunternehmen CuiveMedia, Inhaber Brian Brelöer.
 * Da Einzelunternehmen: kein Handelsregister/HRB, kein "Geschäftsführer".
 */
export default function Impressum(): ReactElement {
  return (
    <div className="pt-24 pb-16 lg:pt-32 lg:pb-24">
      <NoIndex />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-secondary-900 mb-8">Impressum</h1>

        <div className="prose prose-secondary max-w-none space-y-8 text-secondary-700">
          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-3">
              Angaben gemäß § 5 DDG
            </h2>
            <p className="leading-relaxed">
              CuiveMedia
              <br />
              Inhaber: Brian Brelöer
              <br />
              Siriusstraße 2
              <br />
              12524 Berlin
              <br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-3">Kontakt</h2>
            <p className="leading-relaxed">
              Telefon: (030) 89 39 91 47
              <br />
              E-Mail:{' '}
              <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
                info@saldify.de
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-3">
              Umsatzsteuer-Identifikationsnummer
            </h2>
            <p className="leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
              <br />
              DE299006197
            </p>
            <p className="leading-relaxed mt-2">
              Zuständiges Finanzamt: Finanzamt Treptow-Köpenick, 12555 Berlin
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-3">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p className="leading-relaxed">
              Brian Brelöer
              <br />
              Siriusstraße 2
              <br />
              12524 Berlin
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-3">
              Verbraucherstreitbeilegung / Universalschlichtungsstelle
            </h2>
            <p className="leading-relaxed">
              Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren
              vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-secondary-900 mb-3">
              EU-Streitschlichtung
            </h2>
            <p className="leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
              (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
